import { formatCurrency, formatDate } from 'shared/utils';
import { Table } from 'shared/table';
import { Movimiento } from 'core/tarjeta/models/Movimiento';

export const CardAuthorizationsTable = (props: { authorizations: Movimiento[] }) => {
  const montoTotal = () => {
    let total = 0;
    props.authorizations.forEach((item: Movimiento) => {
      total += item.importe;
    });
    return total;
  };

  const printTipoTransaccion = (item: Movimiento) => {
    return (
      (item.tipoOperacion.detalle === 'CONSUMO PESOS' ? 'CONSUMO ' : 'PAGO ') +
      item.moneda.nombre
    );
  };

  return (
    <Table
      thead={
        <tr>
          <td>Fecha</td>
          <td>Establecimiento</td>
          <td>Importe</td>
          <td>Tipo de transacción</td>
        </tr>
      }
      tbody={
        <>
          {props.authorizations.map((item, index) => (
            <tr
              key={`autorizacion${item.tarjeta.numero}`}
              data-testid={'autorizacion-row-' + index}
            >
              <td>{formatDate(item.fecha)}</td>
              <td className="align-left">{item.establecimiento.nombreFantasia}</td>
              <td className="align-right">{formatCurrency(item.importe)}</td>
              <td className="align-left">{printTipoTransaccion(item)}</td>
            </tr>
          ))}
        </>
      }
      tfoot={
        <tr>
          <td colSpan={2}></td>
          <td>{formatCurrency(montoTotal())}</td>
          <td></td>
        </tr>
      }
    />
  );
};
